import { CategoryPageTemplate } from './CategoryPageTemplate'

export function BodySurgeryPage() {
  return <CategoryPageTemplate categoryKey="bodySurgery" namespace="bodySurgery" />
}
